<div #mapcontainer style="width: 100%; position: relative">
    <rask-map [settings]="mapsettings" [refresh]="refresh" [filter]="filter">
        <rask-map-fastighet [hideButton]="false" [importEnabled]="false" (fastighet)="onImportingFastighet($event)">
        </rask-map-fastighet>

        <rask-map-collector
            [hideButton]="isNew()"
            (selection)="onCollectorLasso($event)"
            (visaMapFileImport)="onVisaMapFileImport()"
            (featurelayerChanged)="onChangeLayer($event)">
        </rask-map-collector>

        <rask-map-draw [hideButton]="!canDraw()" [groups]="customDrawGroups"
            (active)="onDrawActive($event)"></rask-map-draw>
        <rask-map-abort-draw></rask-map-abort-draw>
        <rask-map-measure></rask-map-measure>
        <rask-map-fullscreen></rask-map-fullscreen>
        <rask-map-layers></rask-map-layers>
        <div bottom-left-widgets>
            <rask-skogsvard-map-layer-toggle></rask-skogsvard-map-layer-toggle>
        </div>
    </rask-map>
</div>
<div #collector style="position: relative;">
    @if (hasCollectorGeometries()) {
    <rask-vk-karta-collector-popup
        [searchGeometry]="collectorSearchGeometry"
        [useSpringfieldLayer]="useSpringfieldLayer"
        [kontrakt]="entity"
        [kartgeometrier]="kartgeometrier"
        (onImported)="importFromCollector($event)"
        (cancelled)="cancel($event)">
    </rask-vk-karta-collector-popup>
    }
</div>

@if (visaMapFileImport) {
<rask-import-geometries-popup
    (import)="importFromFile($event)"
    [map]="map">
</rask-import-geometries-popup>
}